import React from 'react';
import EditPageDocsGenerateModal from './EditPageDocsGenerateModal';
import FieldSelect from '../fields/FieldSelect';
import * as Row from '../../layout/Row';

export default class EditPageSubstationDocsGenerateModal extends EditPageDocsGenerateModal {

    constructor(props) {
        super(props)

        this.state = {
            ...this.state,
            languageId: null,
            selectedSections: []
        }
    }

    onLanguageChange = item => {
        this.setState({
            languageId: item
        })
    }

    onTechnicalSpecificationItemChange = item => {
        this.setState({
            technicalSpecification: item.value
        })
    }

    renderBody() {
        const languages = this.state.isLoading ? [] : this.state.model.language.items
        return (
            <React.Fragment>
                {this.state.model.technicalSpecification.items.length > 0 && (
                    <React.Fragment>
                        <div className="text-muted specification-scope"
                             style={{paddingBottom: '0.5rem'}}>{__('Specification scope')}</div>
                        {this.renderTechnicalSpecificationItems()}
                    </React.Fragment>
                )}

                <div className="text-muted" style={{paddingBottom: '0.5rem', paddingTop: '1rem'}}>{__('Sections')}</div>
                {this.state.model.outcomes.items.map(this.renderSectionCheckbox)}

                <Row.Container hasOuterGutter={false} className="flex-center-v" style={{paddingTop: '1rem'}}>
                    <Row.Column6>
                        <div className="text-muted">{__('Language')}</div>
                    </Row.Column6>
                    <Row.Column6>
                        <FieldSelect
                            items={languages}
                            value={this.state.languageId}
                            onChange={this.onLanguageChange}
                        />
                    </Row.Column6>
                </Row.Container>
            </React.Fragment>
        )
    }

    renderSectionCheckbox = (item, idx) => {
        const onChange = () => {
            let selectedSections = this.state.selectedSections || []
            if (selectedSections.includes(item.value)) {
                selectedSections.splice(selectedSections.indexOf(item.value), 1)
            } else {
                selectedSections.push(item.value)
            }

            this.setState({
                selectedSections: selectedSections
            })
        };

        let id = Math.random()

        return (
            <div key={idx} style={{padding: '4px 0'}}>
                <input id={id} type="checkbox" checked={this.state.selectedSections.includes(item.value)}
                       onChange={onChange}/>
                <label htmlFor={id}>{item.text}</label>
            </div>
        )
    }

    renderTechnicalSpecificationItems() {
        let option = this.state.technicalSpecification === undefined
            ? this.state.model.technicalSpecification.value
            : this.state.technicalSpecification;

        return (
            <fieldset id="tsitem" className="configuration-editor-docs-generate-ts">
                {this.state.model.technicalSpecification.items.map((item, idx) => (
                    <div key={idx} className="configuration-editor-docs-generate-tsitem">
                        <input id={`tsitem${idx}`} type="radio" name="tsitem" checked={option === item.value}
                               onChange={() => this.onTechnicalSpecificationItemChange(item)}/>
                        <label htmlFor={`tsitem${idx}`}>{item.text}</label>
                    </div>
                ))}
            </fieldset>
        )
    }

    buildPostModel(configurationEditModel) {
        return {
            id: this.props.id,
            projectId: configurationEditModel.projectId,
            type: 'Substation',
            technicalSpecification: this.state.technicalSpecification,
            outcomes: this.state.selectedSections,
            language: this.state.languageId,
            configuration: configurationEditModel
        }
    }

    getDocumentType() {
        return 'Substation';
    }
}